import React from 'react';

import { getWidth } from '../helpers/helpers';

function ColGroup(props) {
  return (
    <colgroup>
      {props.widths.map((width: string | number, index: number) => (
        <col key={index} className={`ink-table--col__${getWidth(width)}`} />
      ))}
    </colgroup>
  );
}

export default ColGroup;
